<template>

  <div class="card" v-if="!currentTab">
    <i :class="component.icon"></i>
    <h5 class="name">{{ component.name }}</h5>
  </div>

  <!-- <div v-else-if="currentTab" @click="$emit('click')">
    <pageView :component="component" />
  </div> -->

</template>

<script>
import pageView from '../components/pageView'
export default {
  name: 'ComponentCard',
  components: { pageView },
  props: {
    icon: String,
    name: String,
    currentTab: Boolean,
    component: {}
  }
}
</script>

<style scoped>
.card {
  float: left;
  width: 100%;
  /* width: 110px;
  height: 110px; */
  /* border-bottom: 1px dotted #e1e1e1;
  border-right: 1px dotted #e1e1e1; */
  border: 1px solid #e1e1e1;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  color: #687382;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 15px -3px;
}

.card:hover {
  background-color: #eff2f7;
  color: #58b7ff;
}

.card i {
  font-size: 20px;
  font-weight: 100;
}

.name {
  font-size: 12px;
  font-weight: normal;
  height: 20px;
  line-height: 20px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ComponentCard.vue